export default "__VITE_ASSET__B1ryT6I2__"